import type { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { Divider } from 'src/components/AzarOnly/Match/Matching/styles';
import { BOTTOM_TAB_BAR_HEIGHT } from 'src/components/BottomTabBar';
import { useDMRoomListQuery } from 'src/hooks/useDirectMessageQuery';
import useUseDMFirstTime from 'src/hooks/useUseDMFirstTime';
import RoomListEmpty from './Empty';
import RoomItem from './Item';
import RoomListSkeleton from './Skeleton';
const List = styled.ul`
  list-style: none;

  margin: 0;
  padding: 0;

  ${({
  theme
}) => theme.screenSize.tablet} {
    margin-bottom: ${BOTTOM_TAB_BAR_HEIGHT};
  }
`;
const DividerWrapper = styled.div`
  padding: 4px 24px;
`;
const RoomList = ({
  children
}: PropsWithChildren) => {
  const {
    data
  } = useDMRoomListQuery();
  const {
    isFirstTime,
    isLoading
  } = useUseDMFirstTime();
  if (isLoading) {
    return <RoomListSkeleton />;
  }
  if (isFirstTime) {
    return <RoomListEmpty />;
  }
  return <List data-sentry-element="List" data-sentry-component="RoomList" data-sentry-source-file="index.tsx">
      {children}
      <DividerWrapper data-sentry-element="DividerWrapper" data-sentry-source-file="index.tsx">
        <Divider data-sentry-element="Divider" data-sentry-source-file="index.tsx" />
      </DividerWrapper>
      {data?.map(room => <RoomItem key={room.messageThreadId} messageThreadInfo={room} />)}
    </List>;
};
export default RoomList;